<template>
  <div>
    <!-- Info -->
    <div class="row mt-4">
      <div class="col-md-12">
        <small>
          {{ infoTotalModels }}
        </small>
      </div>
    </div>

    <!-- Table -->
    <div class="row flex-fill d-flex justify-content-start">
      <div class="col-md-12 mt-2">
        <table class="table table-borderless table-dfe">
          <thead>
          <tr>
            <th>ID</th>
            <th>Conta</th>
            <th>App</th>
            <th>Status</th>
            <th>Kind</th>
            <th>Fase</th>
            <th>Criado por</th>
            <th>Requisitado por</th>
            <th>Modificado em</th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="event in handleEvents" :key="event.id">
            <td>{{ event.id }}</td>
            <td>{{ event.accountId }}</td>
            <td>{{ event.appName }}</td>
            <td>{{ event.status }}</td>
            <td>{{ event.kind }}</td>
            <td>{{ event.stageName }}</td>
            <td>{{ event.createdBy }}</td>
            <td>{{ event.requestedBy }}</td>
            <td>{{ event.changedAt | datetime }}</td>
            <td>
              <button class="btn btn-outline" @click="show(event.id)">
                Show
              </button>
            </td>
          </tr>
          </tbody>
        </table>
      </div>

      <div class="col-md-12 my-1">
        <Pagination
          v-model="meta.currentPage"
          :total-count="meta.totalCount"
          :total-pages="meta.totalPages"
          @pagination="pagination"
        />
      </div>
    </div>

    <ShowDataModal v-model="showModal" header="Event" :data="currentEvent" :deep="3"/>
  </div>
</template>

<script>
import ModelMapper from '@/mixins/ModelMapper'
import GetUser from '@/mixins/GetUser'
import Pagination from '@/components/shares/specialTag/Pagination'

import ShowDataModal from '@/components/admin/ShowDataModal'
import EntityProxy from '@/models/EntityProxy'

export default {
  components: {Pagination, ShowDataModal},
  computed: {
    events() {
      return EntityProxy.build(this.getModels || [])
    },
    handleEvents() {
      const events = []
      this.events.map(event => {
        const newEvent = EntityProxy.build({id: event.id, changedAt: event.createdAt})
        event.mutation.each((key, value) => {
          if (!value) return
          newEvent[this.$parse.toCamelcase(key)] = value[1]
        })
        events.push(newEvent)
      })

      return events
    }
  },
  created() {
    this.$set(this.query, 'periodType', 'created_at')
    this.addOrderBy('created_at')
    this.find()
  },
  data: () => ({
    currentEvent: {},
    showModal: false,
    nameModel: 'Event',
  }),
  methods: {
    buildPath() {
      return `${this.currentPath}/${this.entityOrder.id}/events`
    },
    find() {
      this.asyncTemplateSelect()
    },
    show(eventId) {
      const event = this.events.find(e => e.id === eventId)
      this.showModal = true
      this.currentEvent = event
    }
  },
  mixins: [ModelMapper, GetUser],
  name: 'AdminOrderEvents',
  props: {
    entityOrder: {required: true, type: Object},
    currentPath: {required: true, type: String}
  },
}
</script>
